<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                relastats_etc {{perf}}
                <DataTable :value="relastatsetcs" class="p-datatable-sm" responsiveLayout="scroll" showGridlines stripedRows
                :lazy="true" :paginator="true" :rows="10" ref="dt" dataKey="id"
                :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" @sort="onSort($event)"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50,75,100]"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                selectionMode="single"
                v-model:filters="filters" @filter="onFilter($event)" filterDisplay="row">               
                    <Column field="id" header="id" :sortable="true"></Column>
                    <Column field="odate" header="odate" filterField="odate" filterMatchMode="contains" ref="odate" :sortable="true" :style="{'min-width': '10rem'}">
                      <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="日付" />
                      </template>
                    </Column>                    
                    <Column field="otime" header="otime" :sortable="true"></Column>
                    <Column field="otype" header="otype" filterField="otype" filterMatchMode="contains" ref="otype" :sortable="true" :style="{'min-width': '10rem'}">
                      <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="コード" />
                      </template>
                    </Column> 
                    <Column field="ocd" header="ocd" filterField="ocd" filterMatchMode="contains" ref="ocd" :sortable="true" :style="{'min-width': '10rem'}">
                      <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="コード" />
                      </template>
                    </Column>                     
                    <Column field="oname" header="oname" filterField="oname" filterMatchMode="contains" ref="oname" :sortable="true" :style="{'min-width': '10rem'}">
                      <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter" placeholder="名称" />
                      </template>
                    </Column>
                    <Column field="1d_count" header="1d_count" :sortable="true"></Column>
                    <Column field="close" header="close" :sortable="true"></Column>
                    <Column field="volume" header="volume" :sortable="true"></Column>
                    <Column field="1d_mean" header="1d_mean" :sortable="true">
                      <template #body="slotProps">
                        <div :class="v1dmean_priceClass(slotProps.data)">
                          {{slotProps.data["1d_mean"]}}
                        </div>
                      </template>
                    </Column>
                    <Column field="2d_mean" header="2d_mean" :sortable="true">
                      <template #body="slotProps">
                        <div :class="v2dmean_priceClass(slotProps.data)">
                          {{slotProps.data["2d_mean"]}}
                        </div>
                      </template>
                    </Column>           
                    <Column field="3d_mean" header="3d_mean" :sortable="true">
                      <template #body="slotProps">
                        <div :class="v3dmean_priceClass(slotProps.data)">
                          {{slotProps.data["3d_mean"]}}
                        </div>
                      </template>
                    </Column>    
                    <Column field="5d_mean" header="5d_mean" :sortable="true">
                      <template #body="slotProps">
                        <div :class="v5dmean_priceClass(slotProps.data)">
                          {{slotProps.data["5d_mean"]}}
                        </div>
                      </template>
                    </Column>
                    <Column field="1d_std" header="1d_std" :sortable="true"></Column>
                    <Column field="1d_volume_mean" header="1d_volume_mean" :sortable="true"></Column>
                    <Column field="1d_volume" header="1d_volume" :sortable="true"></Column>
                    <Column field="2d_std" header="2d_std" :sortable="true"></Column>
                    <Column field="2d_volume_mean" header="2d_volume_mean" :sortable="true"></Column>
                    <Column field="3d_std" header="3d_std" :sortable="true"></Column>
                    <Column field="3d_volume_mean" header="3d_volume_mean" :sortable="true"></Column>
                    <Column field="5d_std" header="5d_std" :sortable="true"></Column>
                    <Column field="5d_volume_mean" header="5d_volume_mean" :sortable="true"></Column>
                    <Column field="trendchart_file" header="trendchart_file" :sortable="true"></Column>
                    <Column field="trendchart_status" header="trendchart_status" :sortable="true"></Column>
                    <Column field="trendchart_sdate" header="trendchart_sdate" :sortable="true"></Column>
                    <Column field="trendchart_edate" header="trendchart_edate" :sortable="true"></Column>
                    <Column field="udate" header="udate" :sortable="true"></Column>
                    <Column field="utime" header="utime" :sortable="true"></Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import RelastatsetcService from '@/service/RelastatsetcService';

export default {
    data() {
        return {
            loading: false,
            totalRecords: 0,
            relastatsetcs: null,
            lazyParams: {},
            filters1: {},
            filters: {
                'odate': {value: '', matchMode: 'contains'},
                'otype': {value: '', matchMode: 'contains'},
                'ocd': {value: '', matchMode: 'contains'},
                'oname': {value: '', matchMode: 'contains'},
            },
            perf: null, 
        }
    },
    relastatsetcService: null,
    created() {
        this.relastatsetcService = new RelastatsetcService();
    },
    mounted() {
        this.loading = true;

        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: "-1",
            filters: this.filters
        };

        this.loadLazyData();
    },
    methods: {
        loadLazyData() {
            this.loading = true;

            setTimeout(() => {
                this.relastatsetcService.getAll(
                    {dt_params: JSON.stringify( this.lazyParams )})
                        .then(data => {
                            this.relastatsetcs = data.payload.data;
                            this.totalRecords = data.payload.total;
                            this.loading = false;
                            this.perf = data.perf;
                    }
                );
            }, Math.random() * 1000 + 250);
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter() {
            this.lazyParams.filters = this.filters;
            this.loadLazyData();
        },
        v1dmean_priceClass(data) {
          return [
            {
              'positive': data["1d_mean"] > 0,
              'negative': data["1d_mean"] < 0,
              'neutral': data["1d_mean"] == 0,
            }
          ];
        },
        v2dmean_priceClass(data) {
          return [
            {
              'positive': data["2d_mean"] > 0,
              'negative': data["2d_mean"] < 0,
              'neutral': data["2d_mean"] == 0,
            }
          ];
        },
        v3dmean_priceClass(data) {
          return [
            {
              'positive': data["3d_mean"] > 0,
              'negative': data["3d_mean"] < 0,
              'neutral': data["3d_mean"] == 0,
            }
          ];
        },
        v5dmean_priceClass(data) {
          return [
            {
              'positive': data["5d_mean"] > 0,
              'negative': data["5d_mean"] < 0,
              'neutral': data["5d_mean"] == 0,
            }
          ];
        }
    }
}
</script>

<style scoped lang="scss">
@import '../assets/prod/styles/prices.scss';
</style>